import { render } from "./InfrasFormView.vue?vue&type=template&id=bb32b77a&scoped=true"
import script from "./InfrasFormView.vue?vue&type=script&lang=js"
export * from "./InfrasFormView.vue?vue&type=script&lang=js"

import "./InfrasFormView.vue?vue&type=style&index=0&id=bb32b77a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb32b77a"]])

export default __exports__